import Api from '@/services/Api';

export default {
  getAccountLength() {
    return Api().get('/account/length');
  },
  getAccountList() {
    return Api().get('/account');
  },
  getAccountByMonthAndYear(params: any) {
    if (params && params.month && !params.year) {
      return Api().get(`/account?month=${params.month}`);
    } if (params && !params.month && params.year) {
      return Api().get(`/account?year=${params.year}`);
    }
    return Api().get(`/account?month=${params.month}&year=${params.year}`);
  },
  getAccountByMonthAndYearLength(params: any) {
    if (params && params.month && !params.year) {
      return Api().get(`/account/length?month=${params.month}`);
    } if (params && !params.month && params.year) {
      return Api().get(`/account/length?year=${params.year}`);
    }
    return Api().get(`/account/length?month=${params.month}&year=${params.year}`);
  },
  getExtract(params: any) {
    return Api(true).get(`/account/extract?${params}`, { responseType: 'blob' });
  },
};
